import Tag from "./Tag";
import Tags from "./tags";

export default Tag;

export { Tags };
